<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :title="title" :subtitle="subtitle" />
			<div class="container">
				<div class="row clearfix">
					<div class="column full">
						<div class="spacer height-60"></div>
					</div>

					<!-- カテゴリーリスト -->
					<div class="column full">
						<div class="iv2-news-archive theme-a__news-category px-2">
							<div class="row clearfix">
								<div class="iv2-news-category d-none d-xl-block col-xl-9">
									<div class="iv2-news-category__block d-inline-block">
										<label
											:class="{'active': isActive === 0}"
											class="iv2-news-category__button"
										>
											<input
												@click="clickChange(0)"
												type="radio"
												value=""
												name="category"
												class="iv2-news-category__button-input"
												autocomplete="off"
											/>
											{{ $t('news.all_category') }}
										</label>
										<label
											v-for="category in categories"
											:key="category.id"
											:class="{'active': isActive === category.id}"
											class="iv2-news-category__button"
										>
											<input
												type="radio"
												@click="clickChange(category.id)"
												:value="category.id"
												:id="'sort_' + category.id"
												name="category"
												class="iv2-news-category__button-input"
												autocomplete="off"
											/>
											{{ category.name }}
										</label>
									</div>
								</div>
								<div
									class="iv2-news-category__mobile col-12 d-flex d-xl-none align-items-center justify-content-center"
								>
									<select @change="selectChange($event)" class="iv2-news-category__select w-100 m-3" name="archive">
										<option value=0 >{{ $t('news.all_category') }}</option>
										<option
											v-for="category in categories"
											:key="category.id"
											:value="category.id"
										>{{category.name}}</option>
									</select>
								</div>
								<div class="iv2-news-season col-xl-3 d-flex align-items-center justify-content-center">
									<select
										class="iv2-news-season__select m-1 d-none d-xl-block"
										name="archive"
										@change="selectArchive($event)"
									>
										<option value=0 selected>{{ $t('news.archive') }}</option>
										<option
											v-for="archive in archives"
											:key="archive"
											:value="archive"
										>{{ archive + $t('news.year') }}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 記事一覧 -->
			<LayoutList :news="news" />

			<!-- ページネーション -->
			<div v-if="last_page > 1" class="container">
				<div class="row clearfix">
					<div class="column full text-center">
						<paginate
							:page-count="last_page"
							:page-range="3"
							:margin-pages="2"
							:click-handler="pagination"
							:prev-text="'＜'"
							:next-text="'＞'"
							:container-class="'pagination d-inline-flex'"
							:page-class="'page-item theme__pagination'"
							:page-link-class="'page-link'">
						</paginate>
					</div>
					<div class="column full">
						<div class="spacer height-100"></div>
					</div>
				</div>
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutList from "./components/LayoutList.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutList,
		BaseLoading,
	},

	data() {
		return {
			news: [],
			categories: [],
			current_page: 1,
			archives: [],
			last_page: 1,
			total: 1,
			from: 0,
			to: 0,
			title: "",
			subtitle: "",

			pageActive: false,
			loading: true,
			isActive: 0,
			filterArchive: 9999,
			sortPage: 1,
			sortId: 0,
			sortArchive: 0
		};
	},

	created() {
		this.axios.get('/news/categories').then(({data}) => {
			this.categories = data.response;
		})
		let year = 2020
		let nowDate = new Date().getFullYear()
		let sabun = nowDate - year + 1
		for (let i = 0; i < sabun; i++) {
			this.archives.push(nowDate - i)
		}
	},

	mounted() {
		this.load()
	},

	methods: {
		load() {
			if(this.$route.query.mode == 'preview') {
				this.axios.get('/preview/news', {
					headers: {
						Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
					},
					params: {
						page: this.sortPage,
						category_id: this.sortId,
						year: this.sortArchive
					}
				}).then(({data}) => {
					this.news = data.response.data;
					this.current_page = data.response.current_page;
					this.last_page = data.response.last_page;
					this.total = data.response.total;
					this.from = data.response.from;
					this.to = data.response.to;
					this.title = data.response.title;
					this.subtitle = data.response.subtitle;
					this.loading = false;
					this.pageActive = true;
					window.scrollTo({
						top: 0,
					});
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}else{
				this.axios.get('/news', {
					params: {
						page: this.sortPage,
						category_id: this.sortId,
						year: this.sortArchive
					}
				}).then(({data}) => {
					this.news = data.response.data;
					this.current_page = data.response.current_page;
					this.last_page = data.response.last_page;
					this.total = data.response.total;
					this.from = data.response.from;
					this.to = data.response.to;
					this.title = data.response.title;
					this.subtitle = data.response.subtitle;
					this.loading = false;
					this.pageActive = true;
					window.scrollTo({
						top: 0,
					});
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}
		},

		pagination: function (page) {
			this.loading = true;
			if (page >= 1 && page <= this.last_page) {
				this.sortPage = page;
				this.load();
			}
		},

		clickChange(id) {
			this.loading = true;
			this.sortPage = 1;
			this.sortId = id;
			this.isActive = id;
			this.load();
		},

		selectChange(event) {
			this.loading = true;
			this.sortPage = 1;
			this.sortId = event.target.value;
			this.load();
		},

		selectArchive(event) {
			this.loading = true;
			this.sortPage = 1;
			this.sortArchive = event.target.value;
			this.load();
		}
	},
};
</script>

<style lang="scss">
/* PC */
@media (min-width: 1200px) {
	.iv2-news-archive {
		.iv2-news-season__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			padding-left: 32px;
			border-radius: 0;
			border: 1px solid #000000;
			width: 180px;
			background-color: #ffffff;

			&::-ms-expand {
				display: none;
			}
		}

		.iv2-news-season:before {
			content: "";
			left: 55px;
			top: 42%;
			display: block;
			position: absolute;
			z-index: 3;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: rotate(135deg);
			transform: rotate(135deg);
		}

		.iv2-news-category {
			height: 68px;

			.iv2-news-category__block {
				white-space: nowrap;
				overflow-x: scroll;
				width: 100%;
				-ms-overflow-style: none;    /* IE, Edge 対応 */
				scrollbar-width: none;

				&::-webkit-scrollbar {
					display: none;
				}

				.iv2-news-category__button {
					display: inline-block;
					background-color: transparent;
					border: none;
					border-bottom: 3px solid transparent;
					margin: 0 15px;
					padding: 15px 0;
					-webkit-transition: 0.2s;
					transition: 0.2s;
					cursor: pointer;
					&:hover,
					&.active {
						border-bottom: 3px solid;
					}
					.iv2-news-category__button-input {
						display: none;
						:checked {
							.iv2-news-category__button {
								border-bottom: 3px solid;
							}
						}
					}
					.iv2-news-category__button-name {
						margin: auto;
					}
				}
			}
		}
	}
}
/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-news-archive {
		padding: 10px;
		background-color: transparent !important;

		.iv2-news-category__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			border-radius: 0;
			border: 1px solid #000;
			padding: 0 10px;
			background-color: #fff;
		}

		.iv2-news-category__mobile:before {
			content: "";
			right: 45px;
			display: block;
			position: absolute;
			z-index: 3;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: rotate(135deg);
			transform: rotate(135deg);
		}
	}
}
</style>
